<template>
	<HelloWorld />
</template>

<script>
import HelloWorld from '../components/HelloWorld';

export default {
	components: {
		HelloWorld,
	},
};
</script>
